import moment from "moment-timezone";
import { Boolean, Literal, Record, String, Undefined, Union } from "runtypes";
import { clean } from "./clean";
import { PERSONABLE_LANGUAGE_COLLECTION } from "./collections";
import { currentSemester } from "./current";
export const StudentLanguages = Union(Literal("java"), Literal("kotlin"));
export const Languages = StudentLanguages.Or(Literal("both"));
export const LanguageChoice = Record({
  netID: String,
  staff: Boolean,
  language: Languages
});
export const loadLanguage = async (db, netID) => {
  return LanguageChoice.Or(Undefined).check(
    clean(await db.collection(PERSONABLE_LANGUAGE_COLLECTION).findOne({ netID, invalidated: { $exists: false } }))
  )?.language;
};
export const loadStudentLanguage = async (db, netID) => {
  return StudentLanguages.Or(Undefined).check(
    clean(
      await db.collection(PERSONABLE_LANGUAGE_COLLECTION).findOne({ netID, staff: false, invalidated: { $exists: false } })
    )?.language
  );
};
export const loadStaffLanguage = async (db, netID) => {
  return LanguageChoice.Or(Undefined).check(
    clean(
      await db.collection(PERSONABLE_LANGUAGE_COLLECTION).findOne({ netID, staff: true, invalidated: { $exists: false } })
    )
  )?.language;
};
export const LANGUAGE_CHOICE_LOCKED_DATE = moment(currentSemester.start).add(4, "weeks").toDate();
//# sourceMappingURL=languagechoice.js.map
